import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import IframeView from '../views/IframeView.vue'
import home from '../views/home.vue'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: home
  },
  {
    path: '/viewer1',
    name: '前端应用',
    component: IframeView,
    props: {
      src: '/apps/viewer1/index.html'
    },
    meta: {
      title: 'viewer1'
    }
  },
  {
    path: '/pipeline-monitor',
    name: '油气管道智能监控',
    component: IframeView,
    props: {
      src: '/apps/pipeline-monitor/index.html'
    },
    meta: {
      title: '油气管道智能监控'
    }
  },
  {
    path: '/viewer2',
    name: '静态应用',
    component: IframeView,
    props: {
      src: '/apps/viewer2/index.html'
    },
    meta: {
      title: 'viewer2'
    }
  },
  {
    path: '/box-monitor',
    name: '智能盒子操作界面系统',
    component: IframeView,
    props: {
      src: '/apps/box-monitor/index.html'
    },
    meta: {
      title: '智能盒子操作界面系统'
    }
  },
  {
    path: '/map-monitor',
    name: '管道监测地图导航服务平台',
    component: IframeView,
    props: {
      src: '/apps/map-monitor/index.html'
    },
    meta: {
      title: '管道监测地图导航服务平台'
    }
  },
  {
    path: '/record-monitor',
    name: '管道监测事件智能记录系统',
    component: IframeView,
    props: {
      src: '/apps/record-monitor/index.html'
    },
    meta: {
      title: '管道监测事件智能记录系统'
    }
  },
  {
    path: '/pipeline-inspection-system',
    name: '管道检测区域智能划分系统',
    component: IframeView,
    props: {
      src: '/apps/pipeline-inspection-system/index.html'
    },
    meta: {
      title: '管道检测区域智能划分系统'
    }
  },
  {
    path: '/sentry-system',
    name: '智慧哨岗集成化管理系统',
    component: IframeView,
    props: {
      src: '/apps/sentry-system/index.html'
    },
    meta: {
      title: '智慧哨岗集成化管理系统'
    }
  },
  {
    path: '/smart-sentry-platform',
    name: '智慧哨岗用户信息管理平台',
    component: IframeView,
    props: {
      src: '/apps/smart-sentry-platform/index.html'
    },
    meta: {
      title: '智慧哨岗用户信息管理平台'
    }
  },
  {
    path: '/surveillance-common-system',
    name: '智能哨岗监测综合系统',
    component: IframeView,
    props: {
      src: '/apps/surveillance-common-system/index.html'
    },
    meta: {
      title: '智能哨岗监测综合系统'
    }
  },
  {
    path: '/surveillance-system',
    name: '油气管道监测预警响应系统',
    component: IframeView,
    props: {
      src: '/apps/surveillance-system/index.html'
    },
    meta: {
      title: '油气管道监测预警响应系统'
    }
  }
]

let routerInstance: any = null

export function createAppRouter() {
  if (routerInstance) return routerInstance

  routerInstance = createRouter({
    history: createWebHistory(),
    routes: routes
  })

  routerInstance.afterEach((to: any) => {
    // 从路由元信息中获取标题
    const title = to.meta.title || to.name || '壳应用';
    
    // 更新页面标题
    if (title) {
      document.title = title;
    }
  });

  return routerInstance
}
